// ── AI chat helpers ───────────────────────────────────────────────────────────
import type { ManagerDetail, BacktestFormData, ChatManagerResponse, ChatBacktestResponse } from '@/types'
import { API_BASE } from './base'

export async function managerChat(data: {
    session_id: string,
    message: string,
    context?: Partial<ManagerDetail>
}): Promise<ChatManagerResponse> {
    const res = await fetch(`${API_BASE}/managers/design-chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
    return res.json()
}

export async function BacktestChat(data:{
    session_id: string,
    message: string,
    context?: Partial<BacktestFormData>
}): Promise<ChatBacktestResponse> {
    const res = await fetch(`${API_BASE}/backtest/debug-chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
    return res.json()
}